module.exports = __webpack_public_path__ + "static/media/trip-ms@2x.2c10479d.png";